import React from "react";
import { FieldErrors, FieldValues, UseFormRegister } from "react-hook-form";
import { restrictIntialSpace } from "../../core/services/sharedService";
import { useAppSelector } from "../../core/redux/hooks";

interface MultiPMSConnectionProps {
    register: UseFormRegister<FieldValues>;
    errors: FieldErrors<FieldValues>;
    hummingBirdOrSSM: string;
    toggleValues: (e: React.ChangeEvent<HTMLInputElement>) => void;
    resetField: (name: string) => void;
    setValue: (name: string, value: any) => void;
    pms_name: string;
    ssm_user_id: string;
    ssm_password: string;
    application_id: string;
    company_id: string;
    storageapi_key: string;
    page: string;
}

const MultiPMSconnection = ({ register, errors, hummingBirdOrSSM, toggleValues, resetField, pms_name, ssm_user_id, ssm_password, application_id, company_id, storageapi_key, page, setValue }: MultiPMSConnectionProps) => {
    const LoginUserDetails = useAppSelector((state) => state.auth.users);
    const resetFieldValuesWhenToggled = (e: any) => {
        if (page !== "edit_location") {
            if (e.target.checked !== true) {
                resetField('ssm_user_id');
                resetField('ssm_password');
            } else {
                resetField("application_id");
                resetField("company_id");
                resetField("storageapi_key");
            }
        } else {
            if (e.target.checked !== true) {
                resetField('ssm_user_id');
                resetField('ssm_password');
                setValue('application_id', application_id);
                setValue('company_id', company_id);
                setValue('storageapi_key', storageapi_key);
            } else {
                resetField("application_id");
                resetField("company_id");
                resetField("storageapi_key");
                setValue('ssm_user_id', ssm_user_id);
                setValue('ssm_password', ssm_password);

            }
        }
    };
    React.useEffect(() => {
        setValue('application_id', application_id);
        setValue('company_id', company_id);
        setValue('storageapi_key', storageapi_key);
        setValue('ssm_user_id', ssm_user_id);
        setValue('ssm_password', ssm_password);
    }, []);
    return (
        <>
            <fieldset className="border col-md-8 p-2 mt-2 mb-4" style={{ borderRadius: '5px' }}>
                <legend className="float-none w-auto m-0">PMS Integration Information</legend>
                <div className="row mb-2">
                    <div className="col-md-6">
                        <label>PMS</label>
                    </div>
                    <div className="col-md-6">
                        <input type="checkbox" id="toggle" defaultChecked={hummingBirdOrSSM === "true" ? true : false} onChange={(e) => { toggleValues(e); resetFieldValuesWhenToggled(e) }} className="toggleCheckbox" />
                        <label htmlFor="toggle" className="toggleContainer">
                            <div>HummingBird</div>
                            <div>SSM</div>
                        </label>
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-6">
                        <label>Name</label>
                    </div>
                    <div className="col-md-6">
                        <input
                            type="text"
                            {...register('pms_name', { required: true })}
                            onKeyDown={(e) => restrictIntialSpace(e)}
                            defaultValue={pms_name}
                            className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                        />
                        {errors.pms_name?.type === "required" && <small className="text-danger">PMS Name is required</small>}
                    </div>
                </div>

                {
                    hummingBirdOrSSM === "true" ?
                        (
                            <>
                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <label>SSM USER ID</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            {...register('ssm_user_id', { required: true })}
                                            onKeyDown={(e) => restrictIntialSpace(e)}
                                            defaultValue={ssm_user_id}
                                            className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                        />
                                        {errors.ssm_user_id?.type === "required" && <small className="text-danger">SSM User ID is required</small>}
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <label>SSM PASSWORD</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            {...register('ssm_password', { required: true })}
                                            onKeyDown={(e) => restrictIntialSpace(e)}
                                            defaultValue={ssm_password}
                                            className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                        />
                                        {errors.ssm_password?.type === "required" && <small className="text-danger">SSM PASSWORD is required</small>}
                                    </div>
                                </div>
                            </>

                        ) :
                        (
                            <>
                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <label>RCM Application ID</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            {...register('application_id', { required: true })}
                                            onKeyDown={(e) => restrictIntialSpace(e)}
                                            defaultValue={application_id}
                                            className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                        />
                                        {errors.application_id?.type === "required" && <small className="text-danger">RCM Application ID is required</small>}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <label>Customer PMS Company ID</label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            {...register('company_id', { required: true })}
                                            onKeyDown={(e) => { restrictIntialSpace(e) }}
                                            defaultValue={company_id}
                                            className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                        />
                                        {errors.company_id?.type === "required" && <small className="text-danger">Customer PMS Company ID is required</small>}
                                    </div>
                                </div>
                                <div className="row mb-2">
                                    <div className="col-md-6">
                                        <label>
                                            RCM API Key
                                        </label>
                                    </div>
                                    <div className="col-md-6">
                                        <input
                                            type="text"
                                            {...register('storageapi_key', { required: true })}
                                            onKeyDown={(e) => { restrictIntialSpace(e) }}
                                            defaultValue={storageapi_key}
                                            className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                        />
                                        {errors.storageapi_key?.type === "required" && <small className="text-danger">RCM API Key is required</small>}
                                    </div>
                                </div>
                            </>
                        )

                }
            </fieldset>
        </>
    )
}

export default MultiPMSconnection;